import useHttpQuery from 'data/firestore/useHttpQuery';
import { BusinessHealthResponse } from '../types';

const useBusinessHealthInsights = ({ agentId, date }: { agentId: string; date?: string }) => {
    const queryKey = ['business-health-insights', agentId];
    const params = [];

    if (date) {
        queryKey.push(date.slice(0, 10));
        params.push(`end=${encodeURIComponent(date)}`);
    }

    return useHttpQuery<BusinessHealthResponse>({
        key: queryKey,
        pathname: `/agents/${agentId}/insights/health${params.length > 0 ? `?${params.join('&')}` : ''}`,
        queryOptions: {
            enabled: !!agentId,
        },
    });
};

export default useBusinessHealthInsights;
